"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = exports.createHistory = exports.getHistory = void 0;
var history_1 = require("history");
var miniapp_history_1 = require("miniapp-history");
var env_1 = require("./env");
// eslint-disable-next-line
var history;
exports.history = history;
function createHistory(_a) {
    var routes = _a.routes, customHistory = _a.customHistory, type = _a.type, basename = _a.basename, location = _a.location;
    if (process.env.__IS_SERVER__) {
        exports.history = history = history_1.createMemoryHistory();
        history.location = location;
    }
    else if (customHistory) {
        exports.history = history = customHistory;
    }
    else {
        // Force memory history when env is weex or kraken
        if (env_1.isWeex || env_1.isKraken) {
            type = 'memory';
        }
        if (type === 'hash') {
            exports.history = history = history_1.createHashHistory({ basename: basename });
        }
        else if (type === 'browser') {
            exports.history = history = history_1.createBrowserHistory({ basename: basename });
        }
        else if (env_1.isMiniAppPlatform) {
            window.history = miniapp_history_1.createMiniAppHistory(routes);
            window.location = window.history.location;
            exports.history = history = window.history;
        }
        else {
            exports.history = history = history_1.createMemoryHistory();
        }
    }
    return history;
}
exports.createHistory = createHistory;
function getHistory() {
    return history;
}
exports.getHistory = getHistory;
